import { licenseFeeService } from "@/services/license-fee-service";
import { parseWithZod } from "@conform-to/zod";
import { ActionFunctionArgs, redirect } from "react-router-dom";
import { createToast } from "vercel-toast";
import { z } from "zod";

export const schema = z.object({
  packageId: z.string().optional(),
  startDate: z
    .string({ required_error: "Insira uma data de início." })
    .refine((date) => !isNaN(Date.parse(date)), {
      message: "Insira uma data válida.",
    }),
  endDate: z
    .string({ required_error: "Insira uma data de fim." })
    .refine((date) => !isNaN(Date.parse(date)), {
      message: "Insira uma data válida.",
    }),
  tier: z.string().optional(),
  members: z
    .number({
      required_error:
        "Quantidade de membros é obrigatória, caso não tenham membros, preencher com 0.",
    })
    .min(0, "Quantidade de membros não pode ser negativa."),
  notes: z.string().optional(),
  dealId: z.string().optional(),
});

export async function action({ request, params }: ActionFunctionArgs) {
  if (!params.licenseFeeId) throw redirect("/");

  const formData = await request.formData();
  const submission = parseWithZod(formData, { schema });

  if (submission.status !== "success") {
    return {
      submission: submission.reply(),
    };
  }

  const { value } = submission;
  const { startDate, endDate } = value;

  const startDateObject = new Date(startDate);
  const endDateObject = new Date(endDate);

  if (startDateObject > endDateObject) {
    return {
      submission: submission.reply({
        fieldErrors: {
          endDate: ["A data de fim não pode ser anterior à data de início"],
        },
      }),
    };
  }

  try {
    await licenseFeeService.updateLicenseFee(Number(params.licenseFeeId), {
      ...value,
      packageId: value.packageId ? Number(value.packageId) : undefined,
      notes: value.notes || null,
      dealId: value.dealId || null,
    });

    createToast("License fee editado com sucesso", {
      type: "success",
      timeout: 4000,
    });

    return {
      values: value,
      success: true,
    };
  } catch (error) {
    console.error(error);
    createToast("Erro ao editar license fee", {
      type: "error",
      timeout: 4000,
    });
    return {
      values: value,
    };
  }
}

export type Action = Awaited<ReturnType<typeof action>>;
